import { ICompany } from 'app/shared/model/company.model';

export interface ICompanyToken {
  id?: number;
  token?: string | null;
  activated?: boolean | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<ICompanyToken> = {
  activated: false,
};
